<template>
  <div class="common-page third-party-order">
    <div class="left-box">
      <div class="left-box-content">
        <div class="content-box1">
          <div class="search-form-box">
            <el-row :gutter="20">
              <el-form inline>
                <el-col :span="12">
                  <el-form-item>
                    <el-input
                      style="width: 100%"
                      clearable
                      @input="searchPage"
                      v-model="searchForm.keyword"
                      autocomplete="off"
                      :placeholder="searchForm.userType===31?'请输入服务商':'请输入姓名/手机号码'">
                      <el-select v-model="searchForm.userType" slot="prepend" placeholder="请选择">
                        <el-option label="货主" :value="11"></el-option>
                        <el-option label="司机" :value="21"></el-option>
                        <el-option label="服务商" :value="31"></el-option>
                      </el-select>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <el-input
                      style="width: 100%"
                      clearable
                      @input="searchPage"
                      v-model="searchForm.orderNo"
                      autocomplete="off"
                      placeholder="请输入订单编号" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <custom-date-range
                      :start-date="searchForm.orderTimeStart"
                      :end-date="searchForm.orderTimeEnd"
                      @update:startDate="
                        (val) => (searchForm.orderTimeStart = val)
                      "
                      @update:endDate="(val) => (searchForm.orderTimeEnd = val)"></custom-date-range>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <el-select
                      style="width: 100%"
                      @change="searchPage"
                      v-model="searchForm.orderStatus"
                      filterable
                      allow-create
                      default-first-option
                      clearable
                      placeholder="请选择订单状态">
                      <el-option
                        v-for="item in $dict.orderStatusOptions"
                        :key="item.dictCode"
                        :label="item.dictLabel"
                        :value="item.dictCode"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
          </div>
          <div
            class="custom-table-box"
            v-loading="tableOptions.loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255,255,255,0.8)">
            <template v-if="tableData && tableData.length > 0">
              <div
                class="table-list"
                :class="
                  item.orderId === selectOrderId ? 'table-list-select' : ''
                "
                v-for="(item, index) in tableData"
                :key="item.orderId"
                @click="handleSelectOrder(item, index)">
                <div class="list-content-left">
                  <div class="list-status-label status-error1" v-if="item.orderStatus === 1">待支付</div>
                  <div class="list-status-label status-pending-order1" v-if="item.orderStatus === 10">待派单</div>
                  <div class="list-status-label status-in-progress1" v-if="item.orderStatus === 20">运输中</div>
                  <div class="list-status-label status-confirm1" v-if="item.orderStatus === 100">已完成</div>
                  <div class="list-status-label status-cancel1" v-if="item.orderStatus === 0">已取消</div>
                  <div class="list-date-box">
                    <span class="create-time">装货时间：{{ item.startLoadTime || "-" }}</span>
                    <span class="create-time">下单时间：{{ item.createTime }}</span>
                    <span>订单编号：{{ item.orderNo }}</span>
                  </div>
                  <div class="list-top">
                    <div class="list-top-left">
                      <div class="list-box" v-for="(item2, index) in item.points" :key="index">
                        <div class="list-box-top">
                          <div class="label" :class="item2.loadType === 1 ? 'zhuang' : 'xie'">
                            {{ item2.loadType === 1 ? "装" : "卸" }}
                          </div>
                          <div class="name">{{ item2.cityName }}{{ item2.districtName }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="list-bottom">
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">货主名称</div>
                      <div class="bottom-box-value">{{ item.ownerName }}</div>
                    </div>
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">货主手机号码</div>
                      <div class="bottom-box-value">{{ item.ownerPhone }}</div>
                    </div>
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">承运司机姓名</div>
                      <div class="bottom-box-value">
                        {{ item.driverName || "-" }}
                      </div>
                    </div>
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">手机号码</div>
                      <div class="bottom-box-value">
                        {{ item.driverPhone || "-" }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="no-data" v-else>
              <el-empty :image-size="100" description="暂无订单"></el-empty>
            </div>
          </div>
          <div class="pagination-box">
            <el-pagination
              @size-change="handleSizeChangeS"
              @current-change="handleSizeChangeC"
              :current-page="tableOptions.currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="tableOptions.pageSize"
              background
              layout="total, prev, pager, next, sizes, jumper"
              :total="tableOptions.total" />
          </div>
        </div>
      </div>
    </div>
    <div class="right-box" v-loading="loading">
      <div class="right-content" v-if="selectOrderId">
        <address-template :detail="detail"></address-template>
        <cargo-template :detail="detail"></cargo-template>
        <third-order-template :detail="detail"></third-order-template>
        <order-status-step :details="detail"></order-status-step>
        <driver-template :detail="detail"></driver-template>
        <order-base-template :detail="detail"></order-base-template>
        <order-fee-template :detail="detail"></order-fee-template>
        <div class="operate-confirm" v-if="detail.orderStatus === 20">
          <el-button type="primary" :loading="btnLoading" @click="handleSubmit">订单已完成</el-button>
          <span class="operate-confirm-tip">* 请认真确认订单状态，订单标记为已完成后不可撤回</span>
        </div>
      </div>
      <div class="no-data" v-else>
        <el-empty :image-size="100" description="点击左侧订单查询详情"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { getLocalLabel } from "@/utils/localDict";
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import { getPage, handleExport } from "../../OrderQuery/api";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import CustomSortBox from "@/components/customComponents/CustomSortBox.vue";
import { detailInfo } from "@/views/SchedulingWorkbench/OrderReassignment/api";
import CustomTooltipMultiple from "@/components/CustomTooltipMultiple.vue";
import CustomTooltip from "@/components/CustomTooltip.vue";
import orderStatusStep from "@/components/orderStatusStep.vue";
import { getFileUrl } from "@/utils/tool";
import { rollbackDriver } from "@/views/ApprovalCenter/DriverInformationApproval/api";
import { completeLxOrder } from "@/views/CustomerServiceWorkbench/PendingPriceOrder/api";
import DriverTemplate from "@/components/customComponents/driverTemplate.vue";
import OrderBaseTemplate from "@/components/customComponents/orderBaseTemplate.vue";
import ThirdOrderTemplate from "@/components/customComponents/thirdOrderTemplate.vue";
import CargoTemplate from "@/components/customComponents/cargoTemplate.vue";
import OrderFeeTemplate from "@/components/customComponents/orderFeeTemplate.vue";
import AddressTemplate from "@/components/customComponents/addressTemplate.vue";
export default {
  name: "OrderManagement",
  mixins: [tableMixin],
  components: {
    AddressTemplate, OrderFeeTemplate, CargoTemplate, ThirdOrderTemplate, OrderBaseTemplate,
    DriverTemplate,
    CustomTooltip,
    orderStatusStep,
    CustomTooltipMultiple,
    CustomTabBox,
    CustomSortBox,
    OperateBox,
    CustomTable,
    CustomDateRange,
  },
  data() {
    return {
      getFileUrl,
      btnLoading: false,
      loading: false,
      detail: {},
      cheImage: require("@/assets/imgs/title.png"),
      detailImage: require("@/assets/imgs/title.png"),
      siJiImage: require("@/assets/imgs/siji.png"),
      dngDanImage: require("@/assets/imgs/dngdan.png"),
      getTableMethod: getPage,
      searchForm: {
        companyId: "",
        loadCityCode: "",
        loadDistrictCode: "",
        loadProvinceCode: "",
        orderFrom: "",
        orderNo: "",
        orderStatus: "",
        orderSource: 2,
        keyword: "",
        userType: 11,
        orderTimeStart: "",
        orderTimeEnd: "",
        unloadCityCode: "",
        unloadDistrictCode: "",
        unloadProvinceCode: "",
      },
      isImmediatelyGetData: true,
      selectOrderId: "",
      stepData: [],
      selectTab: 1
    };
  },
  watch: {
    "searchForm.orderTimeStart": function (val) {
      this.getTableData();
    },
  },
  created() {},
  mounted() {},
  methods: {
    getLocalLabel,
    handleSubmit() {
      this.$confirm(`确定提前完成此订单？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        completeLxOrder({
          orderId: this.detail.orderId,
        }).then((res) => {
          if (res.code === 200) {
            this.getOrderDetail(this.detail.orderId);
            this.getTableData();
            this.$emit("success")
          }
        });
      });
    },
    handleChangeStatusTab(val) {
      this.resetSearchForm()
      if (val === 1000) {
        // 模拟的1000 实际没有
        this.searchForm.orderStatus = ""
      } else {
        this.searchForm.orderStatus = val
      }
      this.tableData = []
      this.tableOptions.total = 0
      this.selectOrderId = ''
      this.searchForm.orderSource = this.selectTab
      this.refreshData()
    },
    refreshData() {
      this.tableOptions.currentPage = 1;
      this.getTableData();
    },
    handleSizeChangeS(val) {
      this.tableOptions.pageSize = val;
      this.getTableData();
    },
    handleSizeChangeC(val) {
      this.tableOptions.currentPage = val;
      this.getTableData();
    },
    isCheckDetail(stepStatus, stepType) {
      // 1货主下单，2客服代下单，5货主支付，10调度派单，11订单改派，21装货点装货，22卸货点卸货，31订单取消，41订单退款
      let arr = [5, 10, 11, 21, 22, 31, 41];
      if (stepStatus === 0) {
        return false;
      } else {
        if (arr.includes(stepType)) {
          return true;
        }
        return false;
      }
    },
    handleCheckDetail(item) {
      this.$refs.detail.init(item);
    },
    handleChangeTab(val) {
      this.selectTab = val;
      this.tableData = []
      this.selectOrderId = ''
      this.tableOptions.currentPage = 1;
      this.searchForm.orderSource = val;
      this.getTableData();
    },
    handleCreateOrder() {
      this.$refs.addOrEdit.init();
    },
    openDetail(item) {
      this.$refs.detail.init(item);
    },
    handleChange(val) {
      this.selectTab = val;
      this.$emit("changeTab", this.selectTab);
    },
    handleSelectOrder(item, index) {
      if (this.selectOrderId === item.orderId) {
        return
      }
      this.selectOrderId = item.orderId;
      this.getOrderDetail(item.orderId);
    },
    handleDownLoadTable() {
      this.handleDownload(this.selectTab === 1?'拼满运订单.xlsx':'第三方订单.xlsx')
    },
    getOrderDetail(orderId) {
      this.loading = true;
      detailInfo(orderId)
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            this.detail = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

};
</script>
<style lang="scss" scoped>
.third-party-order {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  .left-box {
    box-sizing: border-box;
    width: 40%;
    height: 100%;
    .left-box-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 0rem 0rem 0;
      box-sizing: border-box;
      border-radius: 0.08rem;

      .custom-table-box {
        //max-height: 90%;
        overflow-y: auto;
        padding-top: 0;

        .table-list {
          width: 100%;
          background: #fbfcff;
          margin-bottom: 0.2rem;
          padding: 0.12rem 0.1rem;
          box-sizing: border-box;
          border: 0.01rem solid #fbfcff;
          border-radius: 0.08rem;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          position: relative;
          .list-content-left {
            flex: 1;

            .list-status-label {
              padding: 0.08rem 0.12rem;
              font-size: 0.12rem;
              border-radius: 0 0.08rem 0 0.08rem;
              position: absolute;
              top: 0;
              right: 0;
            }
            .list-date-box {
              padding-bottom: 0.15rem;
              .create-time {
                padding-right: 0.1rem;
              }
            }
          }
          .list-content-right {
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-shrink: 0;
            padding-top: 0.1rem;
            box-sizing: border-box;
            padding-left: 0.2rem;
            .right-default {
              width: 0.64rem;
              height: 0.21rem;
              border-radius: 0.04rem;
              background-color: #eaf1ff;
              color: #1269ff;
              font-size: 0.12rem;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 0.1rem;
            }
            .right-primary {
              width: 0.64rem;
              height: 0.21rem;
              border-radius: 0.04rem;
              background-color: #1269ff;
              color: #ffffff;
              font-size: 0.12rem;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          .list-top {
            display: flex;
            justify-content: space-between;
            .list-top-left {
              display: flex;
              .list-box {
                padding-right: 0.35rem;
                position: relative;
                .list-box-top {
                  display: flex;
                  align-items: center;
                  .label {
                    flex-shrink: 0;
                    width: 0.2rem;
                    height: 0.2rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 0.02rem;
                    font-size: 0.12rem;
                  }
                  .zhuang {
                    color: #5cc41a;
                    background-color: rgba(92, 196, 26, 0.3);
                  }
                  .xie {
                    color: #e52019;
                    background-color: rgba(229, 32, 25, 0.3);
                  }
                  .name {
                    color: #000000;
                    font-size: 0.16rem;
                    line-height: 0.2rem;
                    padding-left: 0.04rem;
                  }
                }
                .date {
                  color: #8c8c8c;
                  font-size: 0.12rem;
                  line-height: 0.2rem;
                }
              }
              .list-box::before {
                content: "→";
                font-size: 0.2rem;
                position: absolute;
                right: 0.15rem;
                top: 0rem;
                color: #52c41a;
              }
              .list-box:nth-last-of-type(1)::before {
                display: none;
              }
            }
            .list-top-right {

              .right-money {
                display: flex;
                justify-content: right;
                align-items: baseline;
                color: #faad14;

                .unit {
                  font-size: 0.12rem;
                  padding-left: 0.04rem;
                }
              }

              .right-box2 {
                display: flex;
                align-items: center;
                .right-box2-time {
                  font-size: 0.12rem;
                  line-height: 0.2rem;
                  color: #8c8c8c;
                  margin-right: 0.1rem;
                }
                .right-box2-label {
                  background-color: #fff7e6;
                  color: #fa8c16;
                  font-size: 0.12rem;
                  line-height: 0.22rem;
                  border-radius: 0.1rem;
                  padding: 0 0.1rem;
                }
              }
            }
          }
          .list-bottom {
            width: 100%;
            display: flex;
            padding: 0.2rem 0 0;
            .list-bottom-box {
              width: 25%;
              display: flex;
              flex-direction: column;
              position: relative;
              padding-left: 0.1rem;
              box-sizing: border-box;
              .bottom-box-name {
                color: #8c8c8c;
                font-size: 0.12rem;
                margin-bottom: 0.1rem;
              }
              .bottom-box-value {
                color: #434343;
                font-size: 0.14rem;
              }
            }
            .list-bottom-box::before {
              content: "";
              position: absolute;
              right: 0;
              top: 0.08rem;
              width: 0.01rem;
              height: 0.26rem;
              background-color: #dce5f5;
            }
            .list-bottom-box:nth-last-of-type(1)::before {
              display: none;
            }
          }
          .car-box {
            display: flex;
            align-items: center;
            border-top: 0.01rem dashed #dce5f5;
            padding: 0.1rem 0 0;
            .list-1 {
              display: flex;
              align-items: center;

              .label-img {
                width: 0.14rem;
                height: 0.14rem;
              }
              .center-name {
                line-height: 0.2rem;
                padding-left: 0.04rem;
                font-size: 0.14rem;
                color: #52c41a;
              }
            }
            .list-2,
            .list-3 {
              font-size: 0.12rem;
              color: #8c8c8c;
            }
            .list-2 {
              padding: 0 0.2rem;
              position: relative;
              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                left: 0.1rem;
              }
              &::after {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                right: 0.1rem;
              }
            }
          }
        }
        .table-list-select {
          border-color: #1269ff;
          background-color: rgba(18, 105, 255, 0.05);
        }
      }
      .pagination-box {
        display: flex;
        justify-content: right;
        padding: 0.2rem 0.2rem 0.2rem 0;
        background-color: #fff;
      }
    }
  }
  .search-form-box {
    flex-shrink: 0;
  }
  .custom-table-box {
    flex: 1;
  }
  .pagination-box {
    position: sticky;
    bottom: 0;
  }
  .right-box {
    flex: 1;
    height: 100%;
    padding: 0.2rem;
    box-sizing: border-box;
    overflow-y: auto;
    .right-content {
      height: 100%;
      background-color: #ffffff;
      border-radius: 0.08rem;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
    }
  }
  .money {
    font-size: 0.18rem;
    color: #faad14;
  }

  .right-box {
    width: 30%;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    padding: 0rem 0.2rem 0.2rem 0;
    .right-top {
      box-sizing: border-box;
      flex-shrink: 0;
      background-color: #ffffff;
      padding-top: 0.2rem;
      .right-title {
        padding: 0.2rem 0 0;
        .title-label {
          width: 0.08rem;
          height: 0.08rem;
          margin-right: 0.06rem;
        }
      }
      .right-title-tip {
        color: rgba(0, 0, 0, 0.25);
        font-size: 0.12rem;
        line-height: 0.2rem;
        padding: 0.1rem 0;
      }
      .right-search {
        margin: 0.15rem 0 0;
      }
      .sort-car {
        padding: 0.1rem 0;
      }
    }
    .right-center-box {
      flex: 1;
      overflow-y: auto; /* 允许垂直滚动 */
      box-sizing: border-box;
      padding-top: 0.2rem;
      .center-box {
        width: 100%;
        background-color: #fbfcff;
        border-radius: 0.08rem;
        padding: 0 0.1rem;
        box-sizing: border-box;
        cursor: pointer;
        margin-bottom: 0.2rem;
        border: 0.01rem solid #fbfcff;
        overflow: hidden;
        position: relative;
        .label-box {
          position: absolute;
          right: 0;
          top: 0;
          border-radius: 0 0 0 0.08rem;

          width: 0.79rem;
          height: 0.29rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.12rem;
        }
        .label-box1 {
          background: rgba(250, 173, 20, 0.15);
          color: #faad14;
        }
        .label-box2 {
          background: rgba(82, 196, 26, 0.15);
          color: #52c41a;
        }
        .label-box3 {
          background: rgba(18, 105, 255, 0.15);
          color: #1269ff;
        }
        .center-box-name {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.1rem 0;
          .left-box {
            display: flex;
            align-items: center;
            .center-box-1 {
              display: flex;
              align-items: center;
              .label-name {
                width: 0.24rem;
                height: 0.24rem;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #1269ff;
                font-size: 0.12rem;
                background-color: rgba(18, 105, 255, 0.05);
              }
              .center-name {
                line-height: 0.2rem;
                padding-left: 0.04rem;
              }
            }
            .center-box-2 {
              display: flex;
              align-items: center;
              line-height: 0.24rem;
              color: #000000;
              font-size: 0.12rem;
              position: relative;
            }
            .center-box-2 {
              padding-left: 0.2rem;
              position: relative;
              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                left: 0.1rem;
              }
            }
          }

          .center-box-3 {
            flex-shrink: 0;
            line-height: 0.2rem;
            font-size: 0.16rem;
            .default-icon {
              color: #eeeeee;
            }
            .selected-icon {
              color: #52c41a;
            }
          }
        }
        .center-box-car {
          border-top: 0.01rem dashed #dce5f5;
          .car-list {
            display: flex;
            align-items: center;
            padding: 0.08rem 0;
            .center-box-2 {
              padding-right: 0.2rem;
              color: #8c8c8c;
              position: relative;
              font-size: 0.12rem;
              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                right: 0.1rem;
                top: 0.02rem;
              }
            }
            .center-box-2:nth-last-of-type(1)::before {
              display: none;
            }
          }
        }
        .car-operate {
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding: 0.1rem 0;
          background-color: #f4f6fd;
          margin: 0 -0.1rem;
          .operate-list {
            display: flex;
            align-items: center;
            position: relative;
            .operate-img {
              width: 0.14rem;
              height: 0.14rem;
              margin-right: 0.02rem;
            }
            .operate-txt {
              font-size: 0.12rem;
              color: #434343;
            }
          }
          .operate-line {
            width: 0.01rem;
            height: 0.14rem;
            background-color: #e3e7ed;
          }
        }
      }
      .selectTab {
        border: 0.01rem solid #1269ff;
      }
    }
    .right-bottom-operate {
      width: 100%;
      flex-shrink: 0;
      position: sticky;
      bottom: 0rem;
      background-color: #ffffff;
      display: flex;
      justify-content: right;
      padding: 0.15rem 0;
      box-sizing: border-box;
      border-top: 0.01rem solid #e3e7ed;
    }
    .right-content {
      height: 100%;
      padding: 0.2rem 0.16rem;
      box-sizing: border-box;
      .list-top {
        display: flex;
        justify-content: space-between;
        .list-top-left {
          display: flex;
          position: relative;
          .zhuan-date{
            position: absolute;
            bottom: -0px;
            left: 0;
          }
          .left1-box {
            padding-right: 0.35rem;
            position: relative;
            .left1-box-top {
              display: flex;
              align-items: center;
              .label {
                flex-shrink: 0;
                width: 0.2rem;
                height: 0.2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 0.02rem;
                font-size: 0.12rem;
              }
              .zhuang {
                color: #5cc41a;
                background-color: rgba(92, 196, 26, 0.3);
              }
              .xie {
                color: #e52019;
                background-color: rgba(229, 32, 25, 0.3);
              }
              .name {
                color: #000000;
                font-size: 0.16rem;
                line-height: 0.2rem;
                padding-left: 0.04rem;
              }
            }
            .date {
              color: #8c8c8c;
              font-size: 0.12rem;
              line-height: 0.2rem;
            }
          }
          .left1-box::before {
            content: "→";
            font-size: 0.2rem;
            position: absolute;
            right: 0.15rem;
            top: 0rem;
            color: #52c41a;
          }
          .left1-box:nth-last-of-type(1)::before {
            display: none;
          }
        }
        .list-top-right {
          .right-money {
            display: flex;
            justify-content: right;
            align-items: baseline;
            color: #faad14;
            .money {
              font-size: 0.18rem;
              padding-bottom: 0.06rem;
            }
            .unit {
              font-size: 0.12rem;
              padding-left: 0.04rem;
            }
          }
          .right-box2 {
            display: flex;
            align-items: center;
            .right-box2-time {
              font-size: 0.12rem;
              line-height: 0.2rem;
              color: #8c8c8c;
              margin-right: 0.1rem;
            }
            .right-box2-label {
              background-color: #fff7e6;
              color: #fa8c16;
              font-size: 0.12rem;
              line-height: 0.22rem;
              border-radius: 0.1rem;
              padding: 0 0.1rem;
            }
          }
        }
      }
      .list-box {
        background: #f7fbff;
        border-radius: 0.08rem;
        padding: 0.1rem;
        box-sizing: border-box;
        margin-top: 0.2rem;
        .list-bottom {
          width: 100%;
          display: flex;
          padding: 0.08rem 0;
          box-sizing: border-box;
          .list-bottom-box {
            width: 14%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            box-sizing: border-box;
            .list-image {
              width: 0.6rem;
              height: 0.6rem;
              border-radius: 0.05rem;
            }
            .bottom-box-name {
              color: #8c8c8c;
              font-size: 0.12rem;
              margin-bottom: 0.06rem;
            }
            .bottom-box-value {
              color: #434343;
              font-size: 0.14rem;
              text-align: center;
            }
          }
          .list-bottom-box3 {
            width: 40%;
            align-items: flex-start;
            padding-left: 5%;
            box-sizing: border-box;
          }
          .list-bottom-box2 {
            width: 20%;
          }
          .list-bottom-box::before {
            content: "";
            position: absolute;
            right: 0;
            top: 0.06rem;
            width: 0.01rem;
            height: 0.26rem;
            background-color: #dce5f5;
          }
          .list-bottom-box:nth-last-of-type(1)::before {
            display: none;
          }
          .list-bottom-box4 {
            width: 35%;
          }
          .list-bottom-box5 {
            width: 10%;
          }
        }
        //.list-bottom2 {
        //  .list-bottom-box:nth-last-of-type(1):before,
        //  .list-bottom-box:nth-last-of-type(2):before,
        //  .list-bottom-box:nth-last-of-type(3):before,
        //  .list-bottom-box:nth-last-of-type(4):before {
        //    display: none;
        //  }
        //}
      }

      .siji-image,
      .ding-image {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
  }
  .tab-box {
    margin-bottom: 0.2rem;
  }
  .content-box1 {
    width: 100%;
    height: 100%;
    border-radius: 0.08rem;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .to-tab {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0 0.16rem;
      box-sizing: border-box;
    }
  }
  .content-box2 {
    width: 100%;
    height: 100%;
    border-radius: 0.08rem;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    padding: 0 0.2rem;
    box-sizing: border-box;
  }
  .list-bottom-img {
    .list-bottom {
      padding-left: 0.3rem !important;
    }
    .list-bottom-box {
      width: auto !important;
    }
    .list-bottom-box:before {
      display: none;
    }
    .list-image {
      margin-right: 0.1rem;
    }
  }
  .list-status {
    .title-box {
      padding: 0.2rem 0 0;
      .title-label {
        width: 0.08rem;
        height: 0.08rem;
        margin-right: 0.06rem;
      }
    }
    .list-label {
      padding: 0.1rem 0;
    }
    .color8c8c8c {
      color: #8c8c8c;
    }
    .color434343 {
      color: #434343;
    }
    .bgEDF4FF {
      background-color: #edf4ff;
    }
  }
  .siji-image,
  .ding-image {
    width: 0.2rem;
    height: 0.2rem;
  }
}

.list-top{
  position: relative;
  .zhuan-date{
    position: absolute;
    bottom: -0px;
    left: 0;
  }
}
.address{
  padding: 0.1rem 0;
}
.right-ding {
  font-size: 0.14rem;
  padding-bottom: 0.1rem;
}
.operate-confirm{
  margin-top: 0.2rem;
  .operate-confirm-tip{
    padding-left: 0.2rem;
    color: red;
  }
}
</style>
